import React from 'react'
import trusted_user_1 from '../../../../assets/img/trusted-user/0.png'
import trusted_user_2 from '../../../../assets/img/trusted-user/gia.webp'
import trusted_user_3 from '../../../../assets/img/trusted-user/gjepc.webp'
import trusted_user_4 from '../../../../assets/img/trusted-user/igi-gtl.webp'
import trusted_user_5 from '../../../../assets/img/trusted-user/igi.webp'

const Home_Trusted_Customer = () => {
        
  return (
    <div>
         <section className="gi-deal-section py-[40px] max-[767px]:py-[30px] wow fadeInUp" data-wow-duration="2s">
        <div
            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
            <div className="w-full flex flex-wrap px-[12px] overflow-hidden">
                <div className="gi-deal-section w-full">
                    <div className="gi-products">
                        <div className="section-title mb-[20px] relative text-center pb-[20px] z-[5]" data-aos="fade-up"
                            data-aos-duration="2000" data-aos-delay="200">
                            <div className="section-detail">
                                <h2
                                    className="bodonibook_font text-2xl font-bold text-gray-900">
                                    Trusted by 1Lac+ Customers</h2>
                                <p className="mt-[10px] text-[14px] text-[#777] leading-[18px]">OVER 100,000+ SMILES AND
                                    COUNTING</p>
                            </div>

                        </div>
                        <div className="gi-deal-block" data-aos="fade-up" data-aos-duration="2000"
                            data-aos-delay="300">
                            <div className="trusted_user grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 px-[15px] justify-items-center">
                                <div className="px-3">
                                    <img src={trusted_user_1} className="h-20 w-auto object-scale-down" alt="" />
                                </div>
                                <div className="px-3">
                                    <img src={trusted_user_2} className="h-20 w-auto object-scale-down" alt="" />
                                </div>
                                <div className="px-3">
                                    <img src={trusted_user_3} className="h-20 w-auto object-scale-down" alt="" />
                                </div>

                                <div className="px-3">
                                    <img src={trusted_user_4} className="h-20 w-auto object-scale-down" alt="" />
                                </div>
                                <div className="px-3">
                                    <img src={trusted_user_5} className="h-20 w-auto object-scale-down " alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Home_Trusted_Customer